<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 5C0 4.73478 0.105357 4.48043 0.292893 4.29289C0.48043 4.10536 0.734784 4 1 4H3.153C3.38971 4.00011 3.6187 4.08418 3.79924 4.23726C3.97979 4.39034 4.10018 4.6025 4.139 4.836L4.879 9.271C4.91436 9.48222 4.88097 9.69921 4.78376 9.89003C4.68655 10.0809 4.53065 10.2354 4.339 10.331L2.791 11.104C3.34611 12.4797 4.17283 13.7293 5.22178 14.7782C6.27072 15.8272 7.52035 16.6539 8.896 17.209L9.67 15.661C9.76552 15.4695 9.91994 15.3138 10.1106 15.2166C10.3012 15.1194 10.5179 15.0859 10.729 15.121L15.164 15.861C15.3975 15.8998 15.6097 16.0202 15.7627 16.2008C15.9158 16.3813 15.9999 16.6103 16 16.847V19C16 19.2652 15.8946 19.5196 15.7071 19.7071C15.5196 19.8946 15.2652 20 15 20H13C5.82 20 0 14.18 0 7V5Z"
      fill="white"
    />
    <path d="M10 4.28571H20V5.71429H10V4.28571Z" fill="white" />
    <path d="M15.7143 6.24446e-08V10H14.2857V0L15.7143 6.24446e-08Z" fill="white" />
  </svg>
</template>

<script>
export default {
  name: 'AddPhone',
}
</script>

<style scoped></style>
